<!-- topbar.component.html -->

<mat-toolbar class="topbar">
  <div class="topbar-title">
    <button mat-icon-button class="mobile-toggle" (click)="emitToggleSidebar()">
      <mat-icon>menu</mat-icon>
    </button>
    <mat-icon class="title-icon">admin_panel_settings</mat-icon>
    <span class="title-text">Admin Panel</span>
  </div>
  <span class="spacer"></span>

  <!-- Notificaciones -->
  <button mat-icon-button class="notification-btn" [matMenuTriggerFor]="notifMenu" style="margin-right: 16px;">
    <mat-icon [matBadge]="unreadCount > 0 ? unreadCount : null" matBadgeColor="warn" [matBadgeHidden]="unreadCount === 0" aria-hidden="false">notifications</mat-icon>
  </button>
  <mat-menu #notifMenu="matMenu" class="notifications-menu">
    <div class="notif-header" style="padding: 12px; font-weight: bold; border-bottom: 1px solid #333;">
      Notifications ({{ unreadCount }})
      @if (unreadCount > 0) {
        <button mat-button color="primary" (click)="markAllAsRead($event)" style="float: right; transform: scale(0.8); margin-top: -8px;">Mark all read</button>
      }
    </div>
    <div class="notif-list" style="max-height: 300px; overflow-y: auto;">
      @for (alert of recentAlerts; track alert) {
        <div class="notif-item" style="padding: 12px; border-bottom: 1px solid #222;" [ngStyle]="{'background': alert.is_read ? 'transparent' : 'rgba(255,255,255,0.05)'}">
          <div style="font-weight: bold; font-size: 13px;">{{ alert.title }}</div>
          <div style="font-size: 12px; color: #aaa;">{{ alert.message }}</div>
          <div style="font-size: 10px; color: #777; margin-top: 4px;">{{ alert.created_at | date:'short' }}</div>
        </div>
      }
      @if (recentAlerts.length === 0) {
        <div style="padding: 16px; text-align: center; color: #777;">No new notifications.</div>
      }
    </div>
  </mat-menu>

  <!-- Desktop: usuario y logout -->
  @if (user) {
    <div class="user-info desktop">
      <mat-icon class="user-avatar">account_circle</mat-icon>
      <span class="user-name">{{ user.name }}{{ user.surname ? ' ' + user.surname : '' }}</span>
      <span class="user-role" [ngClass]="user.role">{{ user.role }}</span>
      <button mat-icon-button aria-label="Logout" (click)="logout()">
        <mat-icon>logout</mat-icon>
      </button>
    </div>
  }
  <!-- Mobile: menú hamburguesa -->
  @if (user) {
    <div class="mobile-menu">
      <button mat-icon-button [matMenuTriggerFor]="menu">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <div class="user-menu-block">
          <mat-icon class="user-avatar">account_circle</mat-icon>
          <div>
            <div class="user-name">{{ user.name }}{{ user.surname ? ' ' + user.surname : '' }}</div>
            <div class="user-role" [ngClass]="user.role">{{ user.role }}</div>
          </div>
        </div>
        <button mat-menu-item (click)="logout()">
          <mat-icon>logout</mat-icon>
          <span>Logout</span>
        </button>
      </mat-menu>
    </div>
  }
</mat-toolbar>